import { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';

const useStableClientDetails = () => {
  const clientDetailsFromStore = useSelector(state => state.main.clientDetails);
  const lastValidClientDetails = useRef(clientDetailsFromStore);

  useEffect(() => {
    if (!_isEmpty(clientDetailsFromStore)) {
      lastValidClientDetails.current = clientDetailsFromStore;
    }
  }, [clientDetailsFromStore]);

  // Use the last valid clientDetails if current one is empty (e.g., during language switch)
  const clientDetails = _isEmpty(clientDetailsFromStore)
    ? lastValidClientDetails.current
    : clientDetailsFromStore;

  return { clientDetails };
};

export default useStableClientDetails;
